import { createFileRoute } from '@tanstack/react-router'

import { GlobalRoleType } from '@beaded/models'

import { requireGlobalRole } from 'lib/routeGuards'

import ServiceItems from 'pages/ServiceItems'

export const Route = createFileRoute('/_auth/_global/service-items')({
  beforeLoad: requireGlobalRole(
    GlobalRoleType.GLOBAL_EDIT,
    GlobalRoleType.GLOBAL_ADMIN,
  ),
  component: ServiceItems,
})
